import RichSection from './RichSection'

export default RichSection
